import { render, staticRenderFns } from "./PauseDeliveriesConfirmationModal.vue?vue&type=template&id=2cb8d5c5&scoped=true&"
import script from "./PauseDeliveriesConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./PauseDeliveriesConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./PauseDeliveriesConfirmationModal.vue?vue&type=style&index=0&id=2cb8d5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8d5c5",
  null
  
)

export default component.exports